import { API, APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'
class User extends APIObject {
  constructor (options) {
    super('KING', options, true)
    this.defaultOptions()
  }

  defaultOptions (options) {
    // Users from v4/users are identified by `_id` while the checksession user (users.me())
    // is identified by `uid`. `_id` must be set for both, else APIObject.update() skips
    // the debounced auto-save and profile edits are never persisted [DATATR-3644]
    this._id = this._id || this.uid || ''
    this.email = this.email || ''
    this.civility = this.civility || 0
    this.preferences = this.preferences || {}
    this.consent_details = this.consent_details || {}
    this.onboarding = this.onboarding || {}
    this.preferences.home_page_preferences = this.preferences.home_page_preferences || {}
    this.tc_accepted_at = this.tc_accepted_at || null // if the user accepted terms and condition or not
    this.display_name = (this.firstname || this.lastname) ? `${this.firstname} ${this.lastname}`.trim() : this.username || this.name || ''
    this.updatedHomepagePreferences()
  }

  _filter (object) {
    const obj = _omit(super._filter(object), [
      '_id',
      'createdAt',
      'updatedAt',
      'onboarding.trials_left'
    ])
    return obj
  }

  // Update 'data-catalog' to 'connectors' since backend is still using 'data-catalog' in homepage preferences [DATATR-2761]
  updatedHomepagePreferences () {
    const defaultPreferences = this.preferences.home_page_preferences
    if (!defaultPreferences || Object.keys(defaultPreferences).length === 0) return {}
    Object.values(defaultPreferences).forEach(org => {
      org.favorites?.forEach(fav => {
        if (fav.service === 'data-catalog') fav.service = 'connectors'
      })
      org.recent_projects_home?.forEach(service => {
        if (service.type === 'data-catalog') service.type = 'connectors'
      })
    })
  }

  async save () {
    return super.save({
      method: 'PUT',
      retries: 0,
      url: 'v4/profile'
    })
  }

  async resetPassword ({ password, oldpassword }) {
    return await this.request({
      url: 'v4/passwordChange',
      method: 'POST',
      retries: 0,
      data: {
        password,
        oldpassword,
        email: this.email
      }
    })
  }

  async listSession () {
    return await this.request({
      method: 'GET',
      url: 'v4/sessions',
      retries: 0
    })
  }

  async revokeSession (id) {
    return await this.request({
      method: 'DELETE',
      url: `v4/sessions/${id}`,
      retries: 0
    })
  }
}
class Users extends API {
  constructor (ID) {
    super(ID, true)
  }

  async me (options = {}, userClass = false) {
    options.noReconnect = options.noReconnect || false
    options.noOrganizationId = options.noOrganizationId || false

    const user = await this.request({
      method: 'GET',
      url: 'v4/checksession',
      retries: 0,
      ...options
    })

    if (userClass) return new User(user)
    return user
  }

  async list (options = {}, userClass = false) {
    const users = await this.request({
      method: 'GET',
      url: 'v4/users',
      retries: 0,
      ...options
    })
    if (userClass) return users.map(user => new User(user))
    else return users
  }
}

export default Users
export {
  User,
  Users
}
